function getClickedColor(event) {
  const input = event.target.closest('input[type="radio"]');

  if (input && input.value) {
    return input.value.trim();
  }

  const label = event.target.closest('label');

  if (label) {
    const forId = label.getAttribute('for');
    const linkedInput = forId ? document.getElementById(forId) : null;

    if (linkedInput && linkedInput.value) {
      return linkedInput.value.trim();
    }

    return label.textContent.trim();
  }

  return null;
}

function updateComplementaryProducts(forcedColor) {
  const selectedColor = forcedColor;
  if (!selectedColor) return;

  const items = document.querySelectorAll('.mm-variant-match-card');
  if (!items.length) return;

  items.forEach((item) => {
    const variantsJson = item.getAttribute('data-variants');
    if (!variantsJson) return;

    let variants = [];

    try {
      variants = JSON.parse(variantsJson);
    } catch (e) {
      return;
    }

    const matched =
      variants.find(
        (v) =>
          v.option1 === selectedColor ||
          v.option2 === selectedColor ||
          v.option3 === selectedColor
      ) || variants[0];

    if (!matched) return;

    item.querySelectorAll('a').forEach((link) => {
      const baseUrl = link.href.split('?')[0];
      link.href = baseUrl + '?variant=' + matched.id;
    });

    const img = item.querySelector('img');

    if (img && matched.featured_image) {
      const newSrc = matched.featured_image.src;

      img.style.transition = 'opacity 0.25s ease';
      img.style.opacity = '0';

      setTimeout(() => {
        img.src = newSrc;
        img.removeAttribute('srcset');

        if (img.dataset && img.dataset.src) {
          img.dataset.src = newSrc;
        }

        img.style.opacity = '1';
      }, 150);
    }

    const input = item.querySelector('input[name="id"]');
    if (input) {
      input.value = matched.id;
    }

    const quickView = item.querySelector('quick-view');
    if (quickView) {
      const baseQuickViewUrl = quickView.getAttribute('data-product-url').split('?')[0];

      quickView.setAttribute(
        'data-product-url',
        baseQuickViewUrl + '?variant=' + matched.id
      );
    }
  });
}

document.addEventListener('click', function (event) {
  const clickedColor = getClickedColor(event);
  if (!clickedColor) return;

  setTimeout(() => {
    updateComplementaryProducts(clickedColor);
  }, 150);
});

/*
 * Best-effort initial colour match: the card is already colour-matched server-side, but if the
 * theme's `product` scope wasn't available at render time we correct it here by reading the
 * currently-selected colour swatch/radio from the main product's variant picker.
 */
function mmDetectSelectedColor() {
  const picker = document.querySelector(
    'variant-selects, variant-radios, .product-form__input, [data-section-type="product"], .product__info-wrapper'
  );
  const scope = picker || document;
  const checked = scope.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked');
  for (const inp of checked) {
    const nameSet = ((inp.name || '') + ' ' + (inp.dataset ? inp.dataset.optionName || '' : '')).toLowerCase();
    const legend = inp.closest('fieldset') ? (inp.closest('fieldset').querySelector('legend') || {}).textContent || '' : '';
    if (/colou?r|colore/.test(nameSet) || /colou?r|colore/i.test(legend)) {
      if (inp.value) return inp.value.trim();
    }
  }
  return null;
}

function mmInitialColorMatch() {
  const color = mmDetectSelectedColor();
  if (color) updateComplementaryProducts(color);
}

/*
 * Keep "Complete the set" in sync with the cart:
 *  - Hide any card whose product is already in the cart (don't re-recommend what they just added).
 *  - Toggle the 15%-off price preview (.is-qualifying) once the cart holds a qualifying piece.
 *  - Show the subheading on the first still-visible card only.
 *  - Hide the whole module if nothing is left to recommend.
 * Server-side rendering already excludes in-cart items on a fresh load; this handles live updates
 * when the shopper adds an item and closes the drawer without reloading the PDP.
 */
function mmSyncCompleteSet() {
  const cards = document.querySelectorAll('.cts-card[data-cts-card]');
  const container = document.querySelector('.product__upsell');
  fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then((r) => r.json())
    .then((cart) => {
      const items = cart.items || [];
      const handles = new Set(items.map((it) => it.handle));
      const pieces = items.reduce(
        (n, it) => (it.handle === 'make-it-a-gift' ? n : n + it.quantity),
        0
      );
      const qualifies = pieces >= 1;
      cards.forEach((c) => {
        const inCart = handles.has(c.getAttribute('data-product-handle'));
        c.classList.toggle('mm-hide', inCart);
        c.classList.toggle('is-qualifying', qualifies);
      });
      // Subheading shows on the first still-visible card only.
      let firstShown = false;
      cards.forEach((c) => {
        const sub = c.querySelector('.cts-subheading');
        if (!sub) return;
        if (!c.classList.contains('mm-hide') && !firstShown) {
          sub.style.display = 'block';
          firstShown = true;
        } else {
          sub.style.display = 'none';
        }
      });
      // Hide the module entirely if every recommendation is already in the cart.
      if (container) {
        const anyVisible = [...cards].some((c) => !c.classList.contains('mm-hide'));
        container.style.display = anyVisible ? '' : 'none';
      }
    })
    .catch(() => {});
}

// Re-sync after any cart mutation, regardless of the theme's event plumbing.
(function () {
  const origFetch = window.fetch;
  if (typeof origFetch === 'function' && !window.__mmCtsFetchPatched) {
    window.__mmCtsFetchPatched = true;
    window.fetch = function () {
      const req = arguments[0];
      const url = (req && req.url) || (typeof req === 'string' ? req : '');
      const promise = origFetch.apply(this, arguments);
      if (typeof url === 'string' && /\/cart\/(add|change|update|clear)(\.js)?/i.test(url)) {
        promise.then(() => setTimeout(mmSyncCompleteSet, 250)).catch(() => {});
      }
      return promise;
    };
  }
})();

/*
 * Place the "In stock" availability badge to the right of the main price, 16px apart.
 * In the theme markup the price and the .product__inventory badge are separate stacked siblings
 * (with the payment-terms block between them); we wrap them into one flex row. Runs on load and
 * re-applies after the theme re-renders product-info on a variant change.
 */
(function mmPriceRowStyle() {
  if (document.getElementById('mm-price-row-style')) return;
  const s = document.createElement('style');
  s.id = 'mm-price-row-style';
  s.textContent =
    '.mm-price-row{display:flex;align-items:center;gap:16px;flex-wrap:wrap;}' +
    '.mm-price-row .product__price{margin-bottom:0;}' +
    '.mm-price-row .product__inventory{margin-top:0;}' +
    '.cts-card.mm-hide{display:none;}';
  document.head.appendChild(s);
})();

function mmPlaceInventoryByPrice() {
  const info = document.querySelector('.product__info-container');
  if (!info) return;
  const price = info.querySelector(':scope > .product__price');
  const inv = info.querySelector(':scope > .product__inventory');
  if (!price || !inv) return;
  if (price.parentElement && price.parentElement.classList.contains('mm-price-row')) return;
  const row = document.createElement('div');
  row.className = 'mm-price-row';
  price.parentElement.insertBefore(row, price);
  row.appendChild(price);
  row.appendChild(inv);
}

// Re-apply if the theme re-renders the product info (e.g. on variant change).
function mmWatchInfo() {
  const info = document.querySelector('.product__info-container');
  if (!info || info.__mmInvObserved) return;
  info.__mmInvObserved = true;
  const obs = new MutationObserver(() => mmPlaceInventoryByPrice());
  obs.observe(info, { childList: true, subtree: true });
}

['cart:update', 'cart:refresh', 'cartUpdated'].forEach((ev) => {
  document.addEventListener(ev, () => setTimeout(mmSyncCompleteSet, 300));
});
// Re-match colour + re-place the badge when the shopper changes the main product variant.
['variant:change', 'variantChange', 'product:variant-change'].forEach((ev) => {
  document.addEventListener(ev, () => setTimeout(() => { mmInitialColorMatch(); mmPlaceInventoryByPrice(); }, 100));
});
document.addEventListener('DOMContentLoaded', () => {
  mmPlaceInventoryByPrice();
  mmWatchInfo();
  setTimeout(mmPlaceInventoryByPrice, 200);
  setTimeout(mmInitialColorMatch, 300);
  setTimeout(mmSyncCompleteSet, 400);
  setTimeout(mmSyncCompleteSet, 1000);
});
